
import { call, put, takeLatest, takeLeading, takeEvery, fork, all, delay, select, debounce } from 'redux-saga/effects';

import * as Types from '../constants/Types';
import * as Func from "../helpers/functions";
import { parseTourListRequestParams, parseTourLineListRequestParams } from '../utils/commonUtils';
import * as TourService from './../services/tourService';
import i18n from '../constants/initLng';
import { SAGA_DELAY_TIMEOUT, DATE_TIME_FORMAT, PATHS, TOUR_TABS, SAGA_DELAY_TIMEOUT_1000 } from '../constants/Define';
import { notification } from 'antd'
import history from './../helpers/history';
import moment from 'moment';
import { copyTourTicketTranslations } from './copyTourTicketTranslations';

import * as Tour from '../actions/tourAction';

import { omit } from 'lodash'
import { TourLine, TourTicket } from "../models/Tour";
import { tourAutoTranslateRequest, tourTicketAutoTranslateRequest } from 'actions/autoTranslateAction';

// NEW TOUR PROCESSES
function* getListTour() {
    yield takeLatest(Types.TOUR_GET_LIST_ACTION, Func.sagaWrapper(function* (action) {
        const params = parseTourListRequestParams(action.params || {});
        yield delay(SAGA_DELAY_TIMEOUT);
        const result = yield call(TourService.getTours, params);
        yield put(Tour.setListTours({ ...result, params }));
    }, errorHandleTour(Types.TOUR_GET_LIST_FAIL)))
}

function* getAllListTour() {
    yield takeLatest(Types.TOUR_LIST_ALL_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(TourService.getAllTours, action.filters);
        yield put(Tour.dataAllTourSuccess(result));
    }, errorHandleTour(Types.TOUR_GET_LIST_FAIL)))
}

function* exportExcel() {
    yield takeLatest(Types.TOUR_EXPORT_EXCEL_ACTION, Func.sagaWrapper(function* (action) {
        const params = parseTourListRequestParams(action.params || {});
        const result = yield call(TourService.exportExcel, params);
        downloadFileExcel(result);
        Func.sagaSuccessMessage(action, `${i18n.t('notification.downloadSuccess')}`);
        yield put({ type: Types.TOUR_EXPORT_EXCEL_SUCCESS });
    }, errorHandleTour(Types.TOUR_EXPORT_EXCEL_FAIL)))
}

function* cloneTourItem() {
    yield takeLatest(Types.TOUR_CLONE_ITEM_ACTION, Func.sagaWrapper(function* (action) {
         yield call(TourService.cloneTourItem, action.id, action.lengthOfStay, action.isCopyTourTickets);
        Func.sagaSuccessMessage(action, i18n.t('notification.cloneSuccess'));
        yield put({ type: Types.TOUR_GET_LIST_ACTION, params: action.refreshParams })
    }, errorHandleTour(Types.TOUR_DETAIL_FAIL)))
}

function* getTourDetail() {
    yield takeLatest(Types.TOUR_DETAIL_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(TourService.getTourDetail, action.id);
        yield put(Tour.setTourDetail(result));
    }, errorHandleTour(Types.TOUR_DETAIL_FAIL)))
}

function* updateTourDetail() {
    yield takeLatest(Types.TOUR_DETAIL_UPDATE_ACTION, Func.sagaWrapper(function* (action) {
        const { tour } = action.tour;
        
        yield call(TourService.updateTourDetail, tour);
        Func.sagaSuccessMessage({ action, message: `${i18n.t('notification.updateSuccess')}`, description: `${i18n.t('item.tour.title')} "${tour.tourName}"` })
        yield put(Tour.setTourDetail(tour));
        yield put({ type: Types.TAG_GROUP_SKU_MAPPING_UPDATE_ACTION, skuTags: { ...action.tour.skuTags || {} } });

        if (tour.targetLanguage && tour.targetLanguage.length > 0) {
            yield put(tourAutoTranslateRequest({
                sourceId: tour.id,
                sourceLanguage: 'vi-VN',
                targetLanguages: tour.targetLanguage,
            }));
        }
    }, errorHandleTour(Types.TOUR_DETAIL_FAIL)))
}

function* createTourDetail() {
    yield takeLatest(Types.TOUR_DETAIL_CREATE_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(TourService.createTourDetail, action.tour.tour);
        Func.sagaSuccessMessage({ action, message: `${i18n.t('notification.createSuccess')}`, description: `${i18n.t('item.tour.title')} "${action.tour.tour.tourName}"` });
        if(result.data.data && result.data.data.tourId){
            yield put({ type: Types.TAG_GROUP_SKU_MAPPING_UPDATE_ACTION, skuTags: { ...action.tour.skuTags || {}, skuId: result.data.data.tourId } });
        }
        yield delay(1000);
        history.push(PATHS.TOUR.LIST.path);
        history.go();
        yield put(Tour.setTourDetail(action.tour.tour));
    }, errorHandleTour(Types.TOUR_DETAIL_FAIL)))
}

function* deleteTourDetail() {
    yield takeLatest(Types.TOUR_DETAIL_DELETE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(TourService.deleteTourDetail, action.tour);
        Func.sagaSuccessMessage({ action, message: `${i18n.t('notification.removeSuccess')}`, description: `${i18n.t('item.tour.title')} "${action.tour.tourName}"` });
        yield delay(SAGA_DELAY_TIMEOUT);
        yield put(Tour.getListTours(action.refreshParams || {}));
    }, errorHandleTour(Types.TOUR_DETAIL_FAIL)))
}

// TOUR TYPES

function* getAllTourType() {
    yield takeLatest(Types.TOUR_TYPE_GET_ALL_ACTION, Func.sagaWrapper(function* (action) {
        yield delay(SAGA_DELAY_TIMEOUT);
        const result = yield call(TourService.getAllTourTypes);
        yield put(Tour.setAllTourTypes(result));
    }, errorHandleTour(Types.TOUR_TYPE_GET_ALL_FAIL)))
}

function* updateTourTypeDetail() {
    yield takeLatest(Types.TOUR_TYPE_DETAIL_UPDATE_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(TourService.updateTourType, action.tourType);
        tourTypeSuccessMessage(action, `${i18n.t('notification.updateSuccess')}`);
        yield put(Tour.setTourTypeDetail(result));
    }, errorHandleTour(Types.TOUR_TYPE_DETAIL_FAIL)))
}

function* createTourTypeDetail() {
    yield takeLatest(Types.TOUR_TYPE_DETAIL_CREATE_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(TourService.createTourType, action.tourType);
        tourTypeSuccessMessage(action, `${i18n.t('notification.createSuccess')}`);
        yield put(Tour.setTourTypeDetail(result));
    }, errorHandleTour(Types.TOUR_TYPE_DETAIL_FAIL)))
}

function* deleteTourTypeDetail() {
    yield takeLatest(Types.TOUR_TYPE_DETAIL_DELETE_ACTION, Func.sagaWrapper(function* (action) {
        const refreshParams = action.refreshParams || {}; // updateTourDetail
        function* deleteRequest() {
            yield call(TourService.deleteTourType, action.tourType);
            tourTypeSuccessMessage(action, `${i18n.t('notification.removeSuccess')}`);
            yield put(Tour.getAllTourTypes());
        }
        if (refreshParams.tour) {
            yield call(TourService.updateTourDetail, refreshParams.tour);
            yield deleteRequest();
        } else {
            yield deleteRequest();
        }
    }, errorHandleTour(Types.TOUR_TYPE_DETAIL_FAIL)))
}

// TOUR SURCHARGE CATEGORIES
function* getAllSurchargeCategories() {
    yield takeLatest(Types.TOUR_SURCHARGE_CATEGORIES_GET_ALL_ACTION, Func.sagaWrapper(function* (action) {
        yield delay(SAGA_DELAY_TIMEOUT);
        const result = yield call(TourService.getAllSurchargeCategories);
        yield put(Tour.setAllSurchargeCategories(result));
    }, errorHandleTour(Types.TOUR_SURCHARGE_CATEGORIES_GET_ALL_FAIL)))
}

function* createSurchargeCategoriesDetail() {
    yield takeLatest(Types.TOUR_SURCHARGE_CATEGORIES_DETAIL_CREATE_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(TourService.createSurchargeCategories, action.surchargeCategories);
        surchargeCategoriesSuccessMessage(action, `${i18n.t('notification.createSuccess')}`);
        // yield put(Tour.setSurchargeCategoriesDetail(result));
        yield put(Tour.getAllSurchargeCategories())
    }, errorHandleTour(Types.TOUR_SURCHARGE_CATEGORIES_DETAIL_FAIL)))
}

// TOUR LINES

function* getListTourLine() {
    yield takeLatest(Types.TOUR_LINE_GET_LIST_ACTION, Func.sagaWrapper(function* (action) {
        const params = !!action.params && parseTourLineListRequestParams(action.params || {})
        yield delay(SAGA_DELAY_TIMEOUT);
        const result = yield call(TourService.getTourLinesByTour, action.tourId, {...action.params, ...params}, action.isEndpointAdmin);
        yield put(Tour.setListTourLines({ ...result, ...action.params }));
    }, errorHandleTour(Types.TOUR_LINE_GET_LIST_FAIL)))
}

function* getTourLineDetail() {
    yield takeLatest(Types.TOUR_LINE_DETAIL_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(TourService.getTourLineDetail, action.id);
        yield put(Tour.setTourLineDetail(result));
    }, errorHandleTour(Types.TOUR_LINE_DETAIL_FAIL)))
}

function* getTourLineTickets() {
    yield takeLatest(Types.TOUR_LINE_TICKET_GET_ACTION, Func.sagaWrapper(function* (action) {
        const newParams = {...action.params};
        if (!newParams?.isSaleOrder) {
            newParams.isSaleOrder = false;
        }
        const result = yield call(TourService.getTourLineTickets, newParams);
        yield put(Tour.getTourLineTicketsSuccess(result.data.data));
    }, errorHandleTour(Types.TOUR_LINE_DETAIL_FAIL)))
}

function* updateTourLineDetail() {
    yield takeLatest(Types.TOUR_LINE_DETAIL_UPDATE_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(TourService.updateTourLine, action.tourLine);
        tourLineVoucherSuccessMessage(action, i18n.t('validation.statusCode.code.204'), i18n.t('notification.updateSuccess'))
        yield put(Tour.setTourLineDetail(action.tourLine));
        // yield put(Tour.getListTourLines(action.tourLine.tourId, parseTourLineListRequestParams(action.refreshParams || {})));
        // yield delay(500)
        // yield successTicket(action.itemTicket, action.tourLine.id)
    }, errorHandleTour(Types.TOUR_LINE_DETAIL_FAIL)))
}

function* createTourLineDetail() {
    yield takeLatest(Types.TOUR_LINE_DETAIL_CREATE_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(TourService.createTourLine, action.tourLine);
        tourLineVoucherSuccessMessage(action, i18n.t('validation.statusCode.code.201'), i18n.t('notification.createSuccess'))
        yield put(Tour.setTourLineDetail(result));
        yield put(Tour.getListTourLines(action.tourLine.tourId, parseTourLineListRequestParams(action.refreshParams || {})));
    }, errorHandleTour(Types.TOUR_LINE_DETAIL_FAIL)))
}

function* createTourLineBulk() {
    yield debounce(500, Types.TOUR_LINE_BULK_CREATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(TourService.createTourLineBulk, action.tourLineBulk);
        tourLineSuccessMessage(action, `${i18n.t('notification.createSuccess')}`);
        yield put(Tour.getListTourLines(action.tourLineBulk.tourId, getTourLineRefreshParams(action.refreshParams)));
        yield put(Tour.openTourlineBulk(false))
    }, errorHandleTour(Types.TOUR_LINE_BULK_CREATE_FAIL)))
}

const getTicketItemIdsFromTourLineTickets = (tourLineTickets = []) => {
    return (tourLineTickets || []).reduce((ids, ticket) => {
        const tourTicketItems = ticket.tourTicketItems || [];
        return ids.concat(tourTicketItems.map(item => item.id));
    }, []);
}

function* createMissingTourLineTickets(tourLineId, selectedTourTickets = [], existedTicketItemIds = [], selectedTourTicketItemIds = []) {
    for (const tourTicket of selectedTourTickets) {
        const tourTicketItemIds = (tourTicket.tourTicketItems || [])
            .map(item => item.id)
            .filter(id => !selectedTourTicketItemIds.length || selectedTourTicketItemIds.includes(id));
        const missingTourTicketItemIds = tourTicketItemIds.filter(id => !existedTicketItemIds.includes(id));
        if (missingTourTicketItemIds.length > 0) {
            yield call(TourService.createTourItemTicket, {
                tourItemId: tourTicket.id,
                tourLineItemId: tourLineId,
                tourTicketItemIds: missingTourTicketItemIds,
            });
        }
    }
}

const getTourLineRefreshParams = (refreshParams = {}) => ({
    ...refreshParams,
    ...parseTourLineListRequestParams(refreshParams),
});

function* updateTourLinesBulk() {
    yield debounce(500, Types.TOUR_LINE_BULK_UPDATE_ACTION, Func.sagaWrapper(function* (action) {
        const { tourLineBulk } = action;
        const selectedTourLines = tourLineBulk.tourLines || [];
        const selectedTourTickets = tourLineBulk.selectedTourTicket ? [tourLineBulk.selectedTourTicket] : [];

        for (const tourLine of selectedTourLines) {
            const updatedTourLine = new TourLine({
                ...tourLine,
                seats: tourLine.seats || tourLineBulk.seats,
                isEnabled: tourLineBulk.isEnabled,
            });
            yield call(TourService.updateTourLine, updatedTourLine);

            if (selectedTourTickets.length > 0 && (tourLineBulk.tourTicketItemIds || []).length > 0) {
                const tourLineTicketsResult = yield call(TourService.getTourItemTickets, tourLine.id);
                const tourLineTickets = tourLineTicketsResult?.data?.data || [];
                const existedTicketItemIds = getTicketItemIdsFromTourLineTickets(tourLineTickets);
                yield createMissingTourLineTickets(tourLine.id, selectedTourTickets, existedTicketItemIds, tourLineBulk.tourTicketItemIds);
            }
        }

        if (selectedTourLines[0]?.tourId) {
            yield put(Tour.getListTourLines(selectedTourLines[0].tourId, getTourLineRefreshParams(action.refreshParams)));
        }
        tourLineSuccessMessage(action, `${i18n.t('notification.updateSuccess')}`);
    }, errorHandleTour(Types.TOUR_LINE_BULK_UPDATE_FAIL)))
}

function* deleteTourLinesBulk() {
    yield debounce(500, Types.TOUR_LINE_BULK_DELETE_ACTION, Func.sagaWrapper(function* (action) {
        const selectedTourLines = action.tourLines || [];
        const selectedTourLineIds = selectedTourLines.map((tourLine) => tourLine.id).filter(Boolean);
        if (selectedTourLineIds.length > 0) {
            yield call(TourService.deleteTourLinesBulk, selectedTourLineIds);
        }

        if (selectedTourLines[0]?.tourId) {
            yield put(Tour.getListTourLines(selectedTourLines[0].tourId, getTourLineRefreshParams(action.refreshParams)));
        }
        Func.sagaSuccessMessage({ action, message: `${i18n.t('notification.removeSuccess')}` });
    }, errorHandleTour(Types.TOUR_LINE_BULK_DELETE_FAIL)))
}

function* deleteTourLineDetail() {
    yield takeLatest(Types.TOUR_LINE_DETAIL_DELETE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(TourService.deleteTourLine, action.tourLine);
        tourLineVoucherSuccessMessage(action, i18n.t('notification.removeSuccess'))
        // tourLineSuccessMessage(action, `${i18n.t('notification.removeSuccess')}`);
        const listTourLines = yield select((state) => state.tourReducer.detail.tourLines)
        let refreshParams = action.refreshParams
        if (listTourLines.length === 1) {
            refreshParams.fromDate = moment(action.refreshParams).subtract(1, 'm').startOf('month')
            refreshParams.endDate = moment(action.refreshParams).subtract(1, 'm').endOf('month')
        }
        yield put(Tour.getListTourLines(action.tourLine.tourId, parseTourLineListRequestParams(refreshParams || {})));
    }, errorHandleTour(Types.TOUR_LINE_DETAIL_FAIL)))
}

// TRANSLATE
function* createTourTranslate() {
    yield takeLatest(Types.TOUR_CREATE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(TourService.createTourTranslate, action.tour);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.201'), action.tour.translate.languageName);
        yield put({ type: Types.TOUR_CREATE_TRANSLATE_SUCCESS });
        yield put({ type: Types.TOUR_DETAIL_ACTION, id: action.tour.id });
    }, errorHandleTour(Types.TOUR_FAIL)))
}

function* updateTourTranslate() {
    yield takeLatest(Types.TOUR_UPDATE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(TourService.updateTourTranslate, action.tour);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.204'), action.tour.translate.languageName);
        yield put({ type: Types.TOUR_UPDATE_TRANSLATE_SUCCESS });
        yield put({ type: Types.TOUR_DETAIL_ACTION, id: action.tour.id });
    }, errorHandleTour(Types.TOUR_FAIL)))
}

function* deleteTourTranslate() {
    yield takeLatest(Types.TOUR_DELETE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(TourService.deleteTourTranslate, action.tour.translate.id);
        Func.sagaSuccessMessage(action, i18n.t('notification.removeSuccess'), action.tour.translate.languageName);
        yield put({ type: Types.TOUR_DELETE_TRANSLATE_SUCCESS });
        yield put({ type: Types.TOUR_DETAIL_ACTION, id: action.tour.id });
    }, errorHandleTour(Types.TOUR_FAIL)))
}


/* TOURLINE TICKET*/

function* getTourItemTickets() {
    yield takeLatest(Types.TOUR_ITEM_TICKET_GET_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(TourService.getTourItemTickets, action.tourlineId);
        yield put(Tour.setItemTicket(result.data.data, action.tourlineId));
    }, errorHandleTour(Types.TOUR_FAIL)))
}

function* getTourItemTicket() {
    yield takeLatest(Types.TOUR_ITEM_TICKET_DETAIL_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(TourService.getTourItemTicket, action.id);
        // yield put(Tour.setSurchargeDetail(result));
    }, errorHandleTour(Types.TOUR_FAIL)))
}

function* createTourItemTicket() {
    yield takeEvery(Types.TOUR_ITEM_TICKET_DETAIL_CREATE_ACTION, Func.sagaWrapper(function* (action) {
        Func.sagaLoadingMessage(action);
        yield call(TourService.createTourItemTicket, action.itemTicket);
        tourLineTicketSuccessMessage(action, 'updateSuccess', action.itemTicket)
        yield successTicket(action.itemTicket, action.itemTicket.tourLineItemId)
    }, errorHandleTour(Types.TOUR_FAIL)))
}

function* updateTourItemTicket() {
    yield takeLatest(Types.TOUR_ITEM_TICKET_DETAIL_UPDATE_ACTION, Func.sagaWrapper(function* (action) {
        Func.sagaLoadingMessage(action);
        yield call(TourService.updateTourItemTicket, action.itemTicket);
        tourLineTicketSuccessMessage(action, 'updateSuccess', action.itemTicket)
        yield successTicket(action.itemTicket, action.itemTicket.tourLineItemId)
    }, errorHandleTour(Types.TOUR_FAIL)))
}

function* deleteTourItemTicket() {
    yield takeLatest(Types.TOUR_ITEM_TICKET_DETAIL_DELETE_ACTION, Func.sagaWrapper(function* (action) {
        Func.sagaLoadingMessage(action);
        yield call(TourService.deleteTourItemTicket, action.itemTicket.tourLineItemTicketId);
        tourLineTicketSuccessMessage(action, 'removeSuccess', action.itemTicket)
        yield successTicket(action.itemTicket, action.itemTicket.tourLineItemId)
    }, errorHandleTour(Types.TOUR_FAIL)));
}

// TOUR DETAIL TICKET
function* getListDetailTourTicket() {
    yield takeLatest(Types.DETAIL_TOUR_TICKET_GET_ACTION, Func.sagaWrapper(function* (action) {
        const params = parseTourListRequestParams(action.params || {});
        const result = yield call(TourService.getDetailTourTickets, params);
        yield put(Tour.setDetailTourTicketSuccess({ ...result, params }));
    }, errorHandleTour(Types.DETAIL_TOUR_TICKET_FAIL)))
}

function* getDetailTourTicketDetail() {
    yield takeLatest(Types.DETAIL_TOUR_TICKET_DETAIL_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(TourService.getDetailTourTicketDetail, action.id);
        yield put(Tour.setDetailTourTicketDetailSuccess(result));
    }, errorHandleTour(Types.DETAIL_TOUR_TICKET_FAIL)))
}

function* updateDetailTourTicketDetail() {
    yield takeLatest(Types.DETAIL_TOUR_TICKET_DETAIL_UPDATE_ACTION, Func.sagaWrapper(function* (action) {
        const ticketTour = new TourTicket(action.tourTicket, true)
        yield call(TourService.updateDetailTourTicketDetail, ticketTour);
        Func.sagaSuccessMessage({ action, message: `${i18n.t('notification.updateSuccess')}`, description: `${i18n.t('item.tourTicket.title')} "${ticketTour.name}"` })
        
        if (ticketTour.targetLanguage && ticketTour.targetLanguage.length > 0) {
            yield put(tourTicketAutoTranslateRequest({
                sourceId: ticketTour.id,
                sourceLanguage: 'vi-VN',
                targetLanguages: ticketTour.targetLanguage,
            }));
        } else {
            yield delay(SAGA_DELAY_TIMEOUT_1000);
            const result = yield call(TourService.getDetailTourTicketDetail, ticketTour.id);
            yield put(Tour.setDetailTourTicketDetailSuccess(result));
        }
    }, errorHandleTour(Types.DETAIL_TOUR_TICKET_FAIL)))
}

function* createDetailTourTicketDetail() {
    yield takeLeading(Types.DETAIL_TOUR_TICKET_DETAIL_CREATE_ACTION, Func.sagaWrapper(function* (action) {
        const createdTicket = yield call(TourService.createDetailTourTicketDetail, action.tourTicket);
        if (action.copy) {
            if (!createdTicket.id) {
                notification.warning({
                    message: 'Vé đã được tạo nhưng API chưa trả ID vé mới',
                    description: 'Chưa thể sao chép bản dịch. Vui lòng kiểm tra vé vừa tạo trong danh sách.',
                    duration: 0,
                });
                history.replace(Func.getPathWithParams(PATHS.TOUR.DETAIL.path, { id: action.tourTicket.tourId }, TOUR_TABS.TOUR_TICKET.id));
                yield put(Tour.setDetailTourTicketDetailSuccess(createdTicket));
                return;
            }
            const completed = yield call(copyTourTicketTranslations, createdTicket, action.copy.translations, createdTicket.languageCode || action.tourTicket.languageCode);
            if (!completed) {
                history.replace(Func.getPathWithParams(PATHS.TOUR.TICKET.DETAIL.path, { tour_id: action.tourTicket.tourId, id: createdTicket.id }));
                yield put(Tour.getDetailTourTicketDetailAction(createdTicket.id));
                return;
            }
        }
        Func.sagaSuccessMessage({ action, message: `${i18n.t('notification.createSuccess')}`, description: `${i18n.t('item.tourTicket.title')} "${action.tourTicket.name}"` });
        yield delay(SAGA_DELAY_TIMEOUT_1000);
        history.push(Func.getPathWithParams(PATHS.TOUR.DETAIL.path, { id: action.tourTicket.tourId }, TOUR_TABS.TOUR_TICKET.id));
        history.go();
        yield put(Tour.setDetailTourTicketDetailSuccess(action.tourTicket));
    }, errorHandleTour(Types.DETAIL_TOUR_TICKET_FAIL)))
}

function* deleteDetailTourTicketDetail() {
    yield takeLatest(Types.DETAIL_TOUR_TICKET_DETAIL_DELETE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(TourService.deleteDetailTourTicketDetail, action.tourTicket);
        Func.sagaSuccessMessage({ action, message: `${i18n.t('notification.removeSuccess')}`, description: `${i18n.t('item.tourTicket.title')} "${action.tourTicket.nam}"` });
        yield delay(SAGA_DELAY_TIMEOUT);
        history.push(Func.getPathWithParams(PATHS.TOUR.DETAIL.path, { id: action?.tourTicket?.tourId }));
        history.go();
        yield put(Tour.getDetailTourTicketAction(action.refreshParams || {}));
    }, errorHandleTour(Types.DETAIL_TOUR_TICKET_FAIL)))
}

// TRANSLATE TOUR DETAIL TICKET
function* createDetailTourTicketTranslate() {
    yield takeLatest(Types.DETAIL_TOUR_TICKET_CREATE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(TourService.createDetailTourTicketTranslate, action.tourTicket);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.201'), action.tourTicket.translate.languageName);
        yield put({ type: Types.DETAIL_TOUR_TICKET_CREATE_TRANSLATE_SUCCESS });
        yield delay(SAGA_DELAY_TIMEOUT_1000);
        yield put({ type: Types.DETAIL_TOUR_TICKET_DETAIL_ACTION, id: action.tourTicket.id });
    }, errorHandleTour(Types.DETAIL_TOUR_TICKET_FAIL)))
}

function* updateDetailTourTicketTranslate() {
    yield takeLatest(Types.DETAIL_TOUR_TICKET_UPDATE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(TourService.updateDetailTourTicketTranslate, action.tourTicket);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.204'), action.tourTicket.translate.languageName);
        yield put({ type: Types.DETAIL_TOUR_TICKET_UPDATE_TRANSLATE_SUCCESS });
        yield delay(SAGA_DELAY_TIMEOUT_1000);
        yield put({ type: Types.DETAIL_TOUR_TICKET_DETAIL_ACTION, id: action.tourTicket.id });
    }, errorHandleTour(Types.DETAIL_TOUR_TICKET_FAIL)))
}

function* deleteDetailTourTicketTranslate() {
    yield takeLatest(Types.DETAIL_TOUR_TICKET_DELETE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(TourService.deleteDetailTourTicketTranslate, action.tourTicket.translate.id);
        Func.sagaSuccessMessage(action, i18n.t('notification.removeSuccess'), action.tourTicket.translate.languageName);
        yield put({ type: Types.DETAIL_TOUR_TICKET_DELETE_TRANSLATE_SUCCESS });
        yield delay(SAGA_DELAY_TIMEOUT_1000);
        yield put({ type: Types.DETAIL_TOUR_TICKET_DETAIL_ACTION, id: action.tourTicket.id });
    }, errorHandleTour(Types.TOUR_FAIL)))
}

function* successTicket(itemTicket, tourlineId) {
    yield put({ type: Types.TOUR_ITEM_TICKET_GET_ACTION, tourlineId });
}

function tourLineTicketSuccessMessage(action, actionSuccess, itemTicket) {
    return Func.sagaSuccessMessage({
        action,
        message: `${i18n.t('notification.' + actionSuccess)}`,
        value: `${i18n.t('item.tour.ticketName')}: "${itemTicket.name}"`
    });
}

//HANDLER
function errorHandleTour(errorActionType) {
    return Func.sagaErrorHandler(function* (e) {
        yield put({ type: errorActionType })
    }, 'tour');
}

function tourLineVoucherSuccessMessage(action, statusMessage, message = '') {
    if(action.tour.type === 1) {
        Func.sagaSuccessMessage(action, statusMessage, `${moment(action.tour.saleStartDate).format(DATE_TIME_FORMAT.SHORT_DATE)} - ${moment(action.tour.saleEndDate).format(DATE_TIME_FORMAT.SHORT_DATE)}`);
    }  else {
        tourLineSuccessMessage(action, message || statusMessage);
    }
}

function tourLineSuccessMessage(action, message) {
    const isBulkCreate = !!action.tourLineBulk;
    const data = action.tourLine || action.tourLineBulk;
    const dateString = action.tourLineBulk ? `${data.fromDate.format(DATE_TIME_FORMAT.SHORT_DATE)} - ${data.toDate.format(DATE_TIME_FORMAT.SHORT_DATE)}`
        : data.departureDate.format(DATE_TIME_FORMAT.SHORT_DATE)
    let description = `${i18n.t('item.tour.departureDate')} "${dateString}"`;
    if (isBulkCreate) {
        description += ` - "${data.toDate.format(DATE_TIME_FORMAT.SHORT_DATE)}"`;
    }
    return Func.sagaSuccessMessage({ action, message, description })
}

function tourTypeSuccessMessage(action, message) {
    const tourType = action.tourType;
    let description = `${i18n.t('item.tour.tourTypes')} "${tourType.name}"`;
    return Func.sagaSuccessMessage({ action, message, description })
}

function downloadFileExcel(result) {
    // const fileName = result.headers['x-suggestion-filename'];
    const newDate = moment(new Date()).format('DDMMYYYY');
    const fileName = `Products${newDate}`
    const fileType = result.headers['content-type'];
    Func.downloadFile(result.data, fileName, { type: fileType });
}

function surchargeCategoriesSuccessMessage(action, message) {
    const surchargeCategories = action.surchargeCategories;
    let description = `${i18n.t('item.tour.surchargeCategory')} "${surchargeCategories.name}"`;
    return Func.sagaSuccessMessage({ action, message, description })
}


// TagSKUVW

function* getAllTagSKUVW() {
    yield takeLatest(Types.TAGSKUVW_GET_ALL_ACTION, Func.sagaWrapper(function* (action) {
        yield delay(SAGA_DELAY_TIMEOUT);
        const result = yield call(TourService.getAllTagSKUVW);
        yield put(Tour.setAllTagSKUVW(result));
    }, errorHandleTour(Types.TAGSKUVW_GET_ALL_FAIL)))
}

function* updateTagSKUVWDetail() {
    yield takeLatest(Types.TAGSKUVW_DETAIL_UPDATE_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(TourService.updateTagSKUVW, action.tagSKUVW);
        Func.sagaSuccessMessage({ action, message: `${i18n.t('notification.updateSuccess')}` })
        yield put(Tour.getAllTagSKUVW());
    }, errorHandleTour(Types.TAGSKUVW_DETAIL_FAIL)))
}

function* createTagSKUVWDetail() {
    yield takeLatest(Types.TAGSKUVW_DETAIL_CREATE_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(TourService.createTagSKUVW, action.tagSKUVW);
        Func.sagaSuccessMessage({ action, message: `${i18n.t('notification.createSuccess')}` })
        yield put(Tour.getAllTagSKUVW());
    }, errorHandleTour(Types.TAGSKUVW_DETAIL_FAIL)))
}

function* deleteTagSKUVWDetail() {
    yield takeLatest(Types.TAGSKUVW_DETAIL_DELETE_ACTION, Func.sagaWrapper(function* (action) {
        const refreshParams = action.refreshParams || {}; // updateTourDetail
        function* deleteRequest() {
            yield call(TourService.deleteTagSKUVW, action.tagSKUVW);
            Func.sagaSuccessMessage({ action, message: `${i18n.t('notification.removeSuccess')}` })
            yield put(Tour.getAllTagSKUVW());
        }
        if (refreshParams.tour) {
            yield call(TourService.updateTourDetail, refreshParams.tour);
            yield deleteRequest();
        } else {
            yield deleteRequest();
        }
    }, errorHandleTour(Types.TAGSKUVW_DETAIL_FAIL)))
}

export function* tourSaga() {
    yield all([
        //NEW TOUR PROCESSES
        fork(getListTour),
        fork(getAllListTour),
        fork(exportExcel),
        fork(cloneTourItem),
        fork(getTourDetail),
        fork(getTourLineTickets),
        fork(updateTourDetail),
        fork(createTourDetail),
        fork(deleteTourDetail),
        //TOUR TYPES
        fork(getAllTourType),
        fork(updateTourTypeDetail),
        fork(createTourTypeDetail),
        fork(deleteTourTypeDetail),
        //TOUR SURCHAGE CATEGORIES
        fork(getAllSurchargeCategories),
        fork(createSurchargeCategoriesDetail),
        //TOUR LINES
        fork(getListTourLine),
        fork(getTourLineDetail),
        fork(updateTourLineDetail),
        fork(createTourLineDetail),
        fork(deleteTourLineDetail),
        fork(createTourLineBulk),
        fork(updateTourLinesBulk),
        fork(deleteTourLinesBulk),
        //TRANSLATE
        fork(createTourTranslate),
        fork(updateTourTranslate),
        fork(deleteTourTranslate),

        fork(getTourItemTickets),
        fork(getTourItemTicket),
        fork(createTourItemTicket),
        fork(updateTourItemTicket),
        fork(deleteTourItemTicket),
        // DETAIL TOUR TICKET
        fork(getListDetailTourTicket),
        fork(getDetailTourTicketDetail),
        fork(updateDetailTourTicketDetail),
        fork(createDetailTourTicketDetail),
        fork(deleteDetailTourTicketDetail),
        fork(createDetailTourTicketTranslate),
        fork(updateDetailTourTicketTranslate),
        fork(deleteDetailTourTicketTranslate),

        //TOUR TYPES
        fork(getAllTagSKUVW),
        fork(updateTagSKUVWDetail),
        fork(createTagSKUVWDetail),
        fork(deleteTagSKUVWDetail),
    ])
}
